import { __rest } from 'tslib';
import React from 'react';
import HoverableImageLink from '../../Basic/Link/HoverableImageLink/HoverableImageLink.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import { StyledHeading } from './PartnersSection.styles.mjs';
import { useTheme } from 'styled-components';

const PartnersSection = ({ title, partners }) => {
    const theme = useTheme();
    return (React.createElement(FlexContainer, { margin: "1.5rem auto", direction: "column", alignItems: "center" },
        React.createElement(StyledHeading, { tag: "h2", color: theme.colors.invertedTextColor }, title),
        React.createElement(FlexContainer, { maxWidth: "800px", justifyContent: "center", gap: "1.5rem", flexWrap: "wrap" }, partners.map((_a) => {
            var { id } = _a, rest = __rest(_a, ["id"]);
            return (React.createElement(HoverableImageLink, Object.assign({ key: id }, rest)));
        }))));
};

export { PartnersSection as default };
//# sourceMappingURL=PartnersSection.mjs.map
